import React, { Component } from 'react'
import { render } from 'react-dom'

export class Portal extends Component {
	portalElement = null

	componentDidMount() {
		const { id, out } = this.props

		let portalElement = id && document.getElementById( id )

		if( !portalElement )
		{
			portalElement = document.createElement( 'div' )

			portalElement.id = id

			document.getElementById( out ).appendChild( portalElement )
		}

		this.portalElement = portalElement

		this.componentDidUpdate()
	}

	componentWillUnmount() {
		const { out } = this.props

		document.getElementById( out ).removeChild( this.portalElement )
	}

	componentDidUpdate() {
		render( this.props.children, this.portalElement );
	}

	render() {
		return null
	}
}

export class PortalOut extends Component {
	shouldComponentUpdate() {
		return false
	}

    render() {
        return (
            <div { ...this.props }></div>
        )
    }
}